import { apiClientGeral } from '@/plugins/axios'

export default {
  getGrupos() {
    return apiClientGeral().get('/gruposcaptura')
  },
  getGrupo(id) {
    return apiClientGeral().get(`/gruposcaptura/${id}`)
  },
  postGrupo(grupo) {
    return apiClientGeral().post('/gruposcaptura', grupo)
  },
  putGrupo(grupo) {
    return apiClientGeral().put(`/gruposcaptura/${grupo._id}`, grupo)
  },
  deleteGrupos(id) {
    return apiClientGeral().delete(`/gruposcaptura/${id}`)
  },
}
